// @ts-nocheck
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Output,
  Renderer2,
  ViewChild,
  Input,
  Attribute,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
  AbstractControl,
} from '@angular/forms';

@Component({
  selector: 'lib-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
  ],
  exportAs: 'libSwitch',
})
export class SwitchComponent implements ControlValueAccessor, Validator {
  @ViewChild('input', { static: true }) input: ElementRef<HTMLInputElement>;

  @ViewChild('container', { static: true }) container: ElementRef<HTMLElement>;

  @Input() theme: 'primary' | 'warn';

  // tslint:disable-next-line: no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter();

  @Output() update: EventEmitter<boolean> = new EventEmitter();

  @Input()
  set checked(value: string | boolean) {
    this.isChecked = value === '' || value === 'true' || value === true;
  }

  @Input()
  set disabled(value: string | boolean) {
    this.setDisabledState(value === '' || value === 'true' || value === true);
  }

  get class(): string {
    return `lib-switch${this.theme ? `-${this.theme}` : ''}`;
  }

  isChecked: boolean;

  @Input() testAttribute: string | null = null;

  constructor(private renderer: Renderer2) { }

  writeValue(checked: any): void {
    this.isChecked = !!checked;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.input?.nativeElement, 'disabled', isDisabled);
    if (isDisabled) {
      this.renderer.addClass(this.container?.nativeElement, 'disabled');
    } else {
      this.renderer.removeClass(this.container?.nativeElement, 'disabled');
    }
  }

  onChange(event: Event) {
    const inputElement: HTMLInputElement = event?.target as HTMLInputElement;
    this.isChecked = !!inputElement?.checked;
    this.propagateChange(this.isChecked);
    this.change.emit(this.isChecked);
    this.update.emit(this.isChecked);
  }

  validate(control: AbstractControl): { [key: string]: any } | null {
    // return control.errors;
    return null;
  }

  private propagateChange = (_: any) => { };
}
